module.exports = __webpack_public_path__ + "files/397aed0dda1c7cfb0b905dbf777a3f54.png";


//////////////////
// WEBPACK FOOTER
// ./images/googleLogo.png
// module id = 1363
// module chunks = 59